import { Field } from '../../../models/Field'
import { FieldSelectList } from './FieldSelectList'
import { NpsStep } from './NPSStepBasePage'
import { FieldIds, NPSFieldId, NPSStepId, NPSStepProps, StepIds } from './types'
import { NPSRecordState } from './NPSViewModel'
import { NPSWorkflowStep } from './useNPSFormWorkflowCoordinator'
import { validateSelection, validateTopN } from './validation'

export const FEATURE_FEEDBACK_FIELDS: {
    id: NPSFieldId
    selectionLimit?: number
}[] = [
    {
        id: FieldIds.AREAS_EXCEEDING_EXPECTATION,
        selectionLimit: 3,
    },
    {
        id: FieldIds.PRIMARY_VALUE,
    },
    {
        id: FieldIds.AREAS_FALLING_SHORT,
        selectionLimit: 3,
    },
]

export const FEATURE_FEEDBACK_STEP = {
    id: StepIds.FEATURE_AND_VALUE_FEEDBACK,
    validate: ({ getFieldValue }: NPSRecordState) =>
        validateTopN(getFieldValue(FieldIds.AREAS_EXCEEDING_EXPECTATION), 3) &&
        validateSelection(getFieldValue(FieldIds.PRIMARY_VALUE)) &&
        validateTopN(getFieldValue(FieldIds.AREAS_FALLING_SHORT), 3),
} as const satisfies NPSWorkflowStep<NPSStepId>

export function NpsStepFeatureFeedback(props: NPSStepProps) {
    return (
        <NpsStep
            {...props}
            title="PocketSuite Survey"
            fieldGroups={FEATURE_FEEDBACK_FIELDS.map(({ id, selectionLimit }) => {
                // Each field is rendered as a group of one.
                return [
                    {
                        id,
                        sublabel: selectionLimit
                            ? `Please select up to ${selectionLimit} options`
                            : undefined,
                        render: (
                            value: unknown,
                            onChange: (value: unknown) => void,
                            field: Field
                        ) => (
                            <FieldSelectList
                                fieldType={field.type!}
                                options={field.options}
                                value={
                                    Array.isArray(value) || typeof value === 'string'
                                        ? value
                                        : undefined
                                }
                                onChange={onChange}
                                selectionLimit={selectionLimit}
                            />
                        ),
                    },
                ]
            })}
        />
    )
}
